import styled from 'styled-components';

export const Container = styled.div`
  padding: 0px 20px 20px;
`;

export default Container;
